import { createApp } from 'vue'
import i18n from './i18n'
import * as Sentry from "@sentry/vue";

import App from './App.vue'

import store from './store'
import router from './router'

const app = createApp(App)

if(process.env.NODE_ENV === 'production') {
    Sentry.init({
        app,
        dsn: "https://5fb2f42714ff80a5f0f0d6e5defc6144@o402483.ingest.us.sentry.io/4507421261037568",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/api.gallera\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
}

const params = new URLSearchParams(window.location.search);
const vt = params.get('vt');
if (vt) {
    sessionStorage.setItem('utm_token', vt);
    const url = new URL(window.location.href);
    url.searchParams.delete('vt');
    window.history.replaceState({}, '', url.toString());
}

import {fetchUser} from "@/data/requests/user"
import {checkAndLoadFacebookPixel, checkFbPixel, forceProcessQueue} from "@/_helpers/facebook-pixel"

// Ініціалізація Facebook Pixel (з підтримкою cookie consent)
// Перевіряє cookie_consent cookie або параметр cc=accepted з URL
checkAndLoadFacebookPixel();

// Експортуємо діагностичні функції для використання в консолі
(window as any).checkFbPixel = checkFbPixel;
(window as any).forceProcessQueue = forceProcessQueue;

if (store.getters["user/isLoggedIn"]) {
    fetchUser((user) => {
        store.commit('user/setUser', { user })
    })
}

// import 'bootstrap/scss/bootstrap.scss'
// import 'bootstrap/dist/js/bootstrap.bundle'

// import './assets/scss/app.scss'

// import './assets/css/index.css'

//
import ClipboardJS from "clipboard";
import HSTooltip from '@preline/tooltip';

window.ClipboardJS = ClipboardJS;

document.addEventListener("DOMContentLoaded", function() {
    new ClipboardJS('.btn-copy');
    HSTooltip.autoInit();
});

app.provide('$http', window.axios)
    .use(i18n)
    .use(store)
    .use(router)
    .mount('#app')
